// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  
  .container1 {
    position: fixed;
    bottom : 90px;
    right: 24px;
    width: 400px;
    height: 480px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: #FFFFFF;
    border-radius: 8px !important;
    z-index: 1000;
    border: 1px solid #efefef;
    box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.25)  }`, "",{"version":3,"sources":["webpack://./src/pages/Chatbot_v2/components/Chat/Chat.css"],"names":[],"mappings":";;EAEE;IACE,eAAe;IACf,aAAa;IACb,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;IACb,yBAAyB;IACzB,8CAA8C","sourcesContent":["\n  \n  .container1 {\n    position: fixed;\n    bottom : 90px;\n    right: 24px;\n    width: 400px;\n    height: 480px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background: #FFFFFF;\n    border-radius: 8px !important;\n    z-index: 1000;\n    border: 1px solid #efefef;\n    box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.25)  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
